import { useTranslation } from 'react-i18next';

// Import types
import { type VodDetails } from 'types/api/products/vod';

// Import redux actions
import { addFavourite, deleteFavourite } from 'store/actions';

// Import helpers
import { checkIsFavourite } from 'helpers/epg';

// Import hooks
import { useAppDispatch, useAppSelector } from 'store/hooks';

const useFavouriteButton = (uuid: string, GTMEvent?: (buttonText: string) => void) => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const favourites: VodDetails[] = useAppSelector(({ favourites }) => favourites.data);

	const isFavourite = checkIsFavourite(favourites, uuid);
	const buttonText = isFavourite ? t('button_remove') : t('button_add');

	const handleClick = () => {
		GTMEvent && GTMEvent(buttonText);

		return isFavourite ? deleteFavourite(uuid)(dispatch) : addFavourite(uuid)(dispatch);
	};

	return {
		buttonText,
		handleClick,
		isFavourite
	};
};

export default useFavouriteButton;
